import React, { useState } from 'react';
import CybsCard from '@cybs-ui/components/lib/card';
import CybsAlert from '@cybs-ui/components/lib/alert';
import CybsActionBar from '@cybs-ui/components/lib/action-bar';
import CybsFormFooter from '@cybs-ui/components/lib/form-footer';
import AuthTypeDropdown from './auth-type-dropdown';
import HTTPSignatureSet from './http-signature-set';
import JWTSet from './jwt-set';
import SampleRequestDropdown from '../../dynamic/components/combobox/js/sample-request-dropdown';
import ProcessorDropdown from '../../dynamic/components/top-bar/js/secondary-top-bar'
import UrlEditor from '../../dynamic/components/rhs-components/js/url-edit';
import { useSelector } from 'react-redux';
import { putDataInDevCenterDataStore } from '../../../app/store';
import { setDefaultHTTPCredsInCookies, setDefaultJWTCredsInCookies, storeHTTPCreds, storeJWTCreds, setCredCookie} from '../../../commons/cookie';
import showDivBasedOnId, { hideDivBasedOnId } from '../../../commons/ui-commons';
import base64urlEncode, { validateP12Certficate } from '../../../libs/cybs-request-header';
import Link from '@visa/vds/link';
import { getDefaultMerchant, getIsWidget, getMerchantId, getPartnerName } from '../../../lhs/reducers/configuration-reducer';
import KmsDialog from './kms-dialog';
import '../css/static-section.css';
import { getRequestHeaders, getHeaderCounter, getProcessorName} from '../../dynamic/reducers/rhs-schema-reducer';
import { themeBuilder } from "@cybs-plugins/theme";
import { ThemeProvider } from "emotion-theming";
import $ from 'jquery';
import { getPrimarySwatch } from '../../../themeprovider/actions/themes-provider';
import { getAllConfigurationData } from '../../../lhs/reducers/configuration-reducer';

function clearStates(functionList) {
  for (const index in functionList){
    if(!functionList[index])
      functionList[index]('');
  }
}

const updateCredentials = (currentAuthType,merchantId,key,secretKey,jwtmerchantId,p12,jwtPass, src,setPositiveAlert,setNegativeAlert,setMerchantId, setKeyID, setSecretKey, setJWTMerchantId, setJWTPass) => {
    if(currentAuthType === 'HTTP Signature'){       
        storeHTTPCreds(merchantId, key, secretKey)
        var defaultMerchantId = getMerchantId();
        putDataInDevCenterDataStore({type: 'UPDATE_CURRENT_HTTP_MERCHANT_ID', currentHTTPMerchantId: merchantId});
        putDataInDevCenterDataStore({type: 'UPDATE_CURRENT_KEY_ID', currentKeyId: key});
        putDataInDevCenterDataStore({type: 'UPDATE_CURRENT_SECRET_KEY', currentSecretKey: secretKey});
        if(merchantId !== defaultMerchantId){
          showDivBasedOnId('updated-creds-http-api');
          showDivBasedOnId('updated-creds-http-endpoint');
          hideDivBasedOnId('default-creds-http-api');
          hideDivBasedOnId('default-creds-http-endpoint');
          putDataInDevCenterDataStore({type:'UPDATE_DEFAULT_MERCHANT', defaultMerchant:false});
          var headerMap = getRequestHeaders();
          if(headerMap){
            headerMap['v-c-merchantId'] = merchantId;
            putDataInDevCenterDataStore({type:'UPDATE_REQUEST_HEADERS', requestHeaders:headerMap});
            var headerCounter = getHeaderCounter();
            if(headerCounter == undefined){
              putDataInDevCenterDataStore({type:'UPDATE_HEADER_COUNTER', headerCounter:0});
            }
            else{
              putDataInDevCenterDataStore({type:'UPDATE_HEADER_COUNTER', headerCounter:++headerCounter});
            }
          }
        }
        else{
          putDataInDevCenterDataStore({type: 'UPDATE_DEFAULT_MERCHANT', defaultMerchant: true});
        }
        setPositiveAlert({visible: true, message: 'Succesfully updated credentials for HTTP Signature'});
        setNegativeAlert({visible: false, message: ''});
 
        setTimeout(function() {
          setPositiveAlert({visible: false, message: ''});
        },10000);
    }   
    else{
      var filereader = new FileReader();
      filereader.readAsBinaryString(p12[0]);   
      filereader.onload  = function(e) {
        var p12KeysBuffer = filereader.result;
        if(!p12[0]||p12[0].name.length<=0 || p12.size<=0||!validateP12Certficate(jwtmerchantId,p12KeysBuffer,jwtPass)){
          setPositiveAlert({visible: false, message: ''})
          setNegativeAlert({visible: true, message: 'Invalid P12 Credentials'});
          setTimeout(function() {
            setNegativeAlert({visible: false, message: ''});
          },10000);
        }
        else{
          var p12keys = base64urlEncode(p12KeysBuffer);
          storeJWTCreds(jwtmerchantId, p12keys);
          setNegativeAlert({visible: false, message: ''});
          setPositiveAlert({visible: true, message: 'Succesfully updated credentials for Json Web Token'});
          putDataInDevCenterDataStore({type: 'UPDATE_CURRENT_JWT_MERCHANT_ID', currentJWTMerchantId: jwtmerchantId});
          putDataInDevCenterDataStore({type: 'UPDATE_CURRENT_JWT_MERCHANT_KEY', currentJWTMerchantKey: jwtPass});
          setTimeout(function() {
            setPositiveAlert({visible: false, message: ''});
          },10000);
          var defaultMerchantId = getMerchantId();
          $("span[class$='fileSection-fileSection']").textContent = jwtmerchantId+'.p12';
          if(jwtmerchantId !== defaultMerchantId){
            showDivBasedOnId('updated-creds-jwt-api');
            showDivBasedOnId('updated-creds-jwt-endpoint');
            hideDivBasedOnId('default-creds-jwt-api');
            hideDivBasedOnId('default-creds-jwt-endpoint');
            putDataInDevCenterDataStore({type:'UPDATE_DEFAULT_MERCHANT', defaultMerchant:false});
            var headerMap = getRequestHeaders();
            if(headerMap){
              headerMap['v-c-merchantId'] = jwtmerchantId;
              putDataInDevCenterDataStore({type:'UPDATE_REQUEST_HEADERS', requestHeaders:headerMap});
              if(headerCounter == undefined){
                putDataInDevCenterDataStore({type:'UPDATE_HEADER_COUNTER', headerCounter:0});
              }
              else{
                putDataInDevCenterDataStore({type:'UPDATE_HEADER_COUNTER', headerCounter:++headerCounter});
              }
            }
          }
          else{
            putDataInDevCenterDataStore({type:'UPDATE_DEFAULT_MERCHANT', defaultMerchant:true});
          }

      }
    };
  }
}

const AuthenticationCard = (props) => {
  const [merchantId, setMerchantId] = useState('');
  const [jwtmerchantId, setJWTMerchantId] = useState('');
  const [jwtPass, setJWTPass] = useState('');
  const [keyID, setKeyID] = useState('');
  const [secretKey, setSecretKey] = useState('');
  const [p12, setP12] = useState([]);
  const [reset, setReset] = useState(0);
  const [update, setUpdate] = useState(-1);
  const [tfUpdate, setTFUpdate] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [positiveAlert, setPositiveAlert] = useState({visible: false, message: ''});
  const [negativeAlert, setNegativeAlert] = useState({visible: false, message: ''});
  const [openState, changeOpenState] = useState(false);
  const [selectedProcessorLabel, setSelectedProcessorLabel] = useState('');

  var currentAuthType = useSelector(state => state.configurationReducer.currentAuthType);
  if(!currentAuthType){
    currentAuthType = sessionStorage.getItem('currentAuthType')
    if(!currentAuthType){
      putDataInDevCenterDataStore({ type: 'UPDATE_CURRENT_AUTH_TYPE', currentAuthType: 'HTTP Signature' })
      currentAuthType = 'HTTP Signature';
    }
    else{
      putDataInDevCenterDataStore({ type: 'UPDATE_CURRENT_AUTH_TYPE', currentAuthType: currentAuthType })
    }
  }
  React.useEffect(() => {
    if(currentAuthType === 'HTTP Signature'){
      const fetchCookieData = async() => {
        await fetch(
            '/content/bin/sandbox/getHttpCookie',
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache'
              }
            }
        ).then((response) => {
          if (!response.ok) {
            throw new Error('Cookie not found'+response.status);
          } else {
            return response.json();
          }
        }).then(fetchedJsonData => {
          setMerchantId(fetchedJsonData.organizationId);
          setKeyID(fetchedJsonData.keyId);
          setSecretKey(fetchedJsonData.key);
          setDisabled(false);
        }).catch(error => {
          console.error('Error fetching sandbox creds data', error);
        });
      };
      if(update === -1 && reset === 0) {
        fetchCookieData();
      }
    }
  }, [update,reset]);

  React.useEffect(() => {
    const allConfigData = getAllConfigurationData();
    if (allConfigData) {
      const defaultProcessor = allConfigData['defaultProcessor'];
      const processors = allConfigData['processors'];
      if (defaultProcessor && processors && processors[defaultProcessor]) {
        // Get processor label
        const processorLabel = processors[defaultProcessor].processor;
        if (typeof handleProcessorSelect === 'function') {
          handleProcessorSelect(processorLabel);
        }
      }
    }
    }, []);

  var sampleRequestDropDownContents = <div></div>;
  var exampleValue = useSelector(state => state.examplesReducer.exampleValue)
  var exampleData = useSelector(state => state.examplesReducer.exampleKey)
  var linkAddress = "";
  var partnerName = getPartnerName();
  const httpSignatueUrl = 'https://' + window.location.host + `/docs/${partnerName}/en-us/platform/developer/all/rest/rest-getting-started/restgs-about-guide.html`;
  const jwtUrl = 'https://' + window.location.host + `/docs/${partnerName}/en-us/platform/developer/all/rest/rest-getting-started/restgs-about-guide.html`;
  if(currentAuthType === 'HTTP Signature'){
    linkAddress = httpSignatueUrl;
  }
  else {
    linkAddress = jwtUrl;
  }

  var selectedApi = useSelector(state => state.lhsReducer.selectedApi);
  var swatchObject = getPrimarySwatch();

  React.useEffect(function switchState() {
    setDisabled(true);
    if(positiveAlert.visible){
      setPositiveAlert({ visible: false, message: '' })
    }
    if(negativeAlert.visible){
      setNegativeAlert({ visible: false, message: '' })
    }
  }, [currentAuthType])

  React.useEffect(function switchState() {
    if(update>=0){
      updateCredentials(currentAuthType,merchantId,keyID,secretKey,jwtmerchantId,p12,jwtPass, props.src,setPositiveAlert,setNegativeAlert,setMerchantId,setKeyID,setSecretKey,setJWTMerchantId, setJWTPass);
      if(currentAuthType ==='HTTP Signature' && merchantId === 'testrest'){
        clearStates(setKeyID, setSecretKey)
        setDisabled(true);
      }
      setTFUpdate(!tfUpdate);
    }
  }, [update])

  React.useEffect(function switchState() {
    if(currentAuthType === 'HTTP Signature'){
      if(merchantId.length && keyID.length && secretKey.length){
        setDisabled(false);
      }
      else {
        setDisabled(true);
      }
    }
    else {
      if (jwtmerchantId.length && p12.length && jwtPass.length) {
        setDisabled(false);
      }
      else {
        setDisabled(true);
      }
    }
  }, [merchantId, keyID, secretKey, jwtmerchantId, p12, jwtPass])

  React.useEffect(function switchState() {
    // Reset states and get config data
    resetCredentialStates();

    // Retrieve processor data
    const { isVisaPlatformConnect, processorData } = getProcessorData();

    // Set proper credentials based on auth type
    setupCredentials(isVisaPlatformConnect, processorData);

    // Reset UI state
    resetUIState();

    // Update headers
    updateRequestHeaders(isVisaPlatformConnect, processorData);
  }, [reset])

  // Helper functions to reduce complexity

  function resetCredentialStates() {
    clearStates([setMerchantId, setKeyID, setSecretKey, setJWTMerchantId, setJWTPass]);
    putDataInDevCenterDataStore({ type: 'UPDATE_DEFAULT_MERCHANT', defaultMerchant: true });
    setDisabled(true);
  }

  function getProcessorData() {
    const currentProcessorName = getProcessorName();
    const allConfigData = getAllConfigurationData();
    const isVisaPlatformConnect = currentProcessorName === "Visa Platform Connect Certification Testing";

    let processorData = null;
    if (isVisaPlatformConnect && allConfigData?.processors) {
      for (const id in allConfigData.processors) {
        if (allConfigData.processors[id].processor === currentProcessorName) {
          processorData = allConfigData.processors[id];
          break;
        }
      }
    }

    return { isVisaPlatformConnect, processorData };
  }

  function setupCredentials(isVisaPlatformConnect, processorData) {
    if (currentAuthType === 'HTTP Signature') {
      setupHTTPSignatureCredentials(isVisaPlatformConnect, processorData);
    } else {
      setupJWTCredentials(isVisaPlatformConnect, processorData);
    }
  }

  function setupHTTPSignatureCredentials(isVisaPlatformConnect, processorData) {
    if (isVisaPlatformConnect && processorData) {
      const { merchantId, authentication } = processorData;
      const keyId = authentication?.httpSignature?.keyId;
      const secretKey = authentication?.httpSignature?.secretKey;

      setCredCookie('merchantId', merchantId);
      setCredCookie('key', keyId);
      setCredCookie('secretKey', secretKey);
    } else {
      setDefaultHTTPCredsInCookies();
    }

    // Reset store values
    putDataInDevCenterDataStore({ type: 'UPDATE_CURRENT_HTTP_MERCHANT_ID', currentHTTPMerchantId: undefined });
    putDataInDevCenterDataStore({ type: 'UPDATE_CURRENT_KEY_ID', currentKeyId: undefined });
    putDataInDevCenterDataStore({ type: 'UPDATE_CURRENT_SECRET_KEY', currentSecretKey: undefined });
  }

  function setupJWTCredentials(isVisaPlatformConnect, processorData) {
    if (isVisaPlatformConnect && processorData) {
      const merchantId = processorData.merchantId;
      const tokenValue = processorData.authentication?.jwt?.p12Key;

      setCredCookie('jwtMerchantId', merchantId);
      sessionStorage.setItem('jwttoken', tokenValue);
    } else {
      setDefaultJWTCredsInCookies();
    }

    putDataInDevCenterDataStore({ type: 'UPDATE_CURRENT_JWT_MERCHANT_ID', currentJWTMerchantId: undefined });
    putDataInDevCenterDataStore({ type: 'UPDATE_CURRENT_JWT_MERCHANT_KEY', currentJWTMerchantKey: undefined });
  }

  function resetUIState() {
    if (positiveAlert.visible) {
      setPositiveAlert({ visible: false, message: '' });
    }
    if (negativeAlert.visible) {
      setNegativeAlert({ visible: false, message: '' });
    }
  }

  function updateRequestHeaders(isVisaPlatformConnect, processorData) {
    const headerMap = getRequestHeaders();
    if (!headerMap) return;

    // Determine merchant ID for headers
    const headerMerchantId = isVisaPlatformConnect && processorData
      ? processorData.merchantId
      : getMerchantId();

    headerMap['v-c-merchantId'] = headerMerchantId;
    putDataInDevCenterDataStore({ type: 'UPDATE_REQUEST_HEADERS', requestHeaders: headerMap });

    updateHeaderCounter();
  }

  function updateHeaderCounter() {
    let headerCounter = getHeaderCounter();
    const newCounter = headerCounter === undefined ? 0 : ++headerCounter;
    putDataInDevCenterDataStore({ type: 'UPDATE_HEADER_COUNTER', headerCounter: newCounter });
  }

  React.useEffect(function switchState() {  
    if (positiveAlert.visible) {
      setPositiveAlert({ visible: false, message: '' })
    }
    if (negativeAlert.visible) {
      setNegativeAlert({ visible: false, message: '' })
    }
  }, [selectedApi])

  const handleProcessorSelect = (label) => {
    setSelectedProcessorLabel(label);
  };

  if(props.src == 'API' && exampleValue != "" && exampleData != undefined && !getIsWidget()){
    sampleRequestDropDownContents = (
        <div id="sampleRequestDropDownDiv">
          <SampleRequestDropdown selectedProcessorLabel={selectedProcessorLabel}/>
        </div>
    );
  }
  if(props != undefined){
    if(swatchObject != undefined){
      var theme = themeBuilder(swatchObject);
      return (
        <ThemeProvider theme={theme}>
          <div class="authCard" >
            <KmsDialog openState={openState} changeOpenState={changeOpenState} setPositiveAlert={setPositiveAlert} setNegativeAlert={setNegativeAlert} src={props.src} setP12={setP12} />
            <CybsCard
              className="authentication-card"
              dataTest="payment-info-with-button"
              header={props.src === 'Endpoint' &&
                <CybsActionBar
                  i18n={{ title: "Authentication and Sandbox Credentials" }}
                  dataTest="payment-info-with-button"
                />
              }
            >
              <CybsAlert
                isInline
                isDismissable
                i18n={{
                  message: positiveAlert.message
                }}
                status="positive"
                isVisible={positiveAlert.visible}
                onDismiss={() => setPositiveAlert({ visible: false, message: '' })}
              />

              <CybsAlert
                isInline
                isDismissable
                i18n={{
                  message: negativeAlert.message
                }}
                status="negative"
                isVisible={negativeAlert.visible}
                onDismiss={() => setNegativeAlert({ visible: false, message: '' })}
              />
              {props.src == 'API' &&
                  <div id="configurationTab">
                    <span id="urlLabel">URL</span>
                    <UrlEditor/>
                    <div class="PaymentProcessorType">
                      <ProcessorDropdown onProcessorSelect={handleProcessorSelect}/>
                    </div>
                    {sampleRequestDropDownContents}
                  </div>
              }
                  <div id="outer-authentication-content">
                    <div class="authenticationCardDetails">
                      Authentication
                    </div>
                    <div id="combobox-information">
                      <p>There are two forms of authentication available: JSON Web Token (JWT) and HTTP Signature. JWT requires signing a P12 Certificate while HTTP Signature is a hash-based method which uses a shared secret key. Authorization Headers are generated based on payload for each request. To learn more about authentication headers <Link class="color_theme_link" href={linkAddress} rel="noopener" target="_blank">click here</Link></p>
                    <p>For your convenience, you can quickly configure this API Console to send all sample requests with either method, using your own sandbox credentials or the default API Console credentials.</p>

                    <AuthTypeDropdown src={props.src} />

                    {currentAuthType > 'HTTP Signature' &&  <p>Please enter the password, which was established during the key generation process, into the designated password field.</p>}
                  </div>
                  {currentAuthType < 'Json Web Token' && <HTTPSignatureSet setMerchantId={setMerchantId} setKeyID={setKeyID} setSecretKey={setSecretKey} reset={reset} update={tfUpdate} src={props.src} dialogStateSetter={changeOpenState} merchantId={merchantId} keyID={keyID} secretKey={secretKey} />}
                  {currentAuthType > 'HTTP Signature' && <JWTSet setJWTMerchantId={setJWTMerchantId} setP12={setP12} setJWTPass={setJWTPass} reset={reset} update={update} src={props.src} dialogStateSetter={changeOpenState} jwtMerchantId={jwtmerchantId} p12={p12} jwtPass={jwtPass} />}
                </div>
            </CybsCard>
              <CybsFormFooter
                dataTest="payment-test"
                rightButtons={[
                  {
                    label: 'Update Credentials',
                    onClick: () => setUpdate((update + 1) % 2),
                    colorScheme: 'primary',
                    id: 'upd_cre',
                    style: { width: 'fit-content', color: 'white' },
                    disabled: disabled
                  },
                  {
                    label: (props.src == 'Endpoint') ? 'Reset' : 'Reset to Default',
                    onClick: () => setReset((reset + 1) % 2),
                    className: 'tertiary',
                    colorScheme: 'tertiary',
                    id: 'reset',
                    iconClass: 'reload',
                    iconLocation: 'left',
                    style: { width: 'fit-content' }
                  }
                ]}
              />
          </div>
        </ThemeProvider>
      );
    }
    else{
      return (
        <div>
        </div>
      )
    }
  }
  else{
    return (
      <div>
      </div>
    )
  }
}

AuthenticationCard.displayName = 'AuthenticationCard';
export default AuthenticationCard;


  